import { jsx as _jsx } from "react/jsx-runtime";
import { PrimaryButton, Stack } from '@fluentui/react';
/**
 * This is the footer content for the Feature Panel.
 */
export const FeaturePanelFooterContent = ({ setIsFeaturePanelOpen, }) => (_jsx(Stack, Object.assign({ horizontalAlign: 'end' }, { children: _jsx(PrimaryButton, Object.assign({ iconProps: { iconName: 'Cancel' }, onClick: () => setIsFeaturePanelOpen(false) }, { children: "Close" })) })));
